<template>
  <div class="w-full h-full flex flex-col items-center justify-center p-8">
    <div
      class="w-2/3 max-w-sm -mt-24 pointer-events-none lottieContainer min-h-24"
    >
      <LottieComponent :src="$constants.FEE.LOTTIES.LOADING_ERROR" loop />
    </div>
    <div class="py-2"></div>
    <div class="text-center text-2xl font-bold">Erreur de chargement</div>
    <div class="py-1"></div>
    <slot name="errorDescription">
      <div class="text-center text-lg">Impossible de charger les frais</div>
    </slot>
    <div class="py-1"></div>
    <button class="buttonComponent" @click="$emit('refresh')">
      Réessayer
    </button>
  </div>
</template>
